import { combineReducers, Reducer } from '@reduxjs/toolkit'
import { IReconBreakDetailData, IReconData } from 'api/recondata.types'
import {
  reducer as dqrSeiBreakDetailReducer,
  sagas as dqrSeiBreakDetailSagas
} from 'modules/ReconAIDataQuality/features/SEIDashboard/store'
import {
  reducer as reconDataSummaryReducer,
  sagas as reconDataSummarySagas,
  breakDetailReducer as breakDetailDataSummaryReducer,
  breakDetailSagas as breakDetailDataSummarySagas
} from 'modules/ReconAIDataQuality/store'

import { IListsState } from './core/store/reducers'

export interface IListsFeatureState {
  reconDataSummary: IListsState<IReconData>
  breakDetailDataSummary: IListsState<IReconBreakDetailData>
  dqrSeiBreakDetail: IListsState<IReconBreakDetailData>
}

export const reducer: Reducer<IListsFeatureState> = combineReducers({
  reconDataSummary: reconDataSummaryReducer,
  breakDetailDataSummary: breakDetailDataSummaryReducer,
  dqrSeiBreakDetail: dqrSeiBreakDetailReducer
})
export const sagas = [
  ...reconDataSummarySagas,
  ...breakDetailDataSummarySagas,
  ...dqrSeiBreakDetailSagas
]
